var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header-radio"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"address"},_vm._l((_vm.btnList),function(item,index){return _c('div',{key:index,class:[index === _vm.active ? 'active' : '', item ? 'btn' : ''],on:{"click":function($event){_vm.current = index;
          _vm.handleClickBtn(index);}}},[_vm._v(" "+_vm._s(item.label + "(" + item.num + ")")+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }